import Splide from "@splidejs/splide";

export default class BlogCategorySlider {

	static getHolderSelectors = () => ['.blog-category-slider-element'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {

		const slideSettings = {
			type: 'loop',
			arrows: false,
			gap: '2.5rem',
			fixedWidth: '25.25rem',
			pagination: false,
			focus: 'center',
			width: '100vw',
			breakpoints: {
				720: {
					fixedWidth: '90vw',
				}
			}
		};
		const slider = new Splide(holderElement.querySelector('.splide'), slideSettings);
		slider.mount();


		holderElement.querySelectorAll('[data-slider-move]').forEach(btn => {
			btn.addEventListener('click', event => {
				const direction = event.currentTarget.dataset.sliderMove;
				slider.go(direction);
			});
		});
	}

}
